<!-- Detalle de Centro · Información general (ui-redesign): lectura (kv) / edición (controles). -->
<form [formGroup]="myDetailForm" class="cards">
	<div class="card-row">
		<!-- ============ DATOS DEL CENTRO ============ -->
		<div class="card">
			<div class="sec-head">
				<span class="sec-tile red"><mat-icon>apartment</mat-icon></span>
				<div>
					<h3>{{ "centro.detail.dataTitle" | translate }}</h3>
					<p>{{ "centro.detail.dataSub" | translate }}</p>
				</div>
			</div>
			<div class="kv-grid">
				<!-- Código (siempre lectura). Debajo, el código corto persistido (ADR-0016):
				     identificador del centro en el sistema anterior y en las integraciones. -->
				<div class="kv">
					<div class="kv-k">{{ "centro.centroData.code" | translate }}</div>
					<div class="kv-v" style="font-family: var(--mono)">{{ centro?.codigo || "—" }}
						<button *ngIf="centro?.codigo" type="button" class="code-copy" (click)="copyCodigo(centro?.codigo)" [matTooltip]="'contracts.codes.copy' | translate"><mat-icon [inline]="true">content_copy</mat-icon></button>
					</div>
					<div class="kv-codes-legacy" *ngIf="centro?.codigoCorto">
						<div class="code-row">
							<span class="code-lbl">{{ "contracts.codes.corto" | translate }}</span>
							<span class="code-val">{{ centro?.codigoCorto }}</span>
							<button type="button" class="code-copy" (click)="copyCodigo(centro?.codigoCorto)" [matTooltip]="'contracts.codes.copy' | translate"><mat-icon [inline]="true">content_copy</mat-icon></button>
							<mat-icon class="code-info" matTooltipPosition="above" [matTooltip]="'centro.codes.cortoInfo' | translate">info_outline</mat-icon>
						</div>
					</div>
				</div>

				<!-- Estado (activo) -->
				<div class="kv">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.centroData.active" | translate }}</div>
						<div class="kv-v"><span class="opx-badge" [ngClass]="estadoActivo ? 'ok' : 'gray'">{{ (estadoActivo ? "common.active" : "common.inactive") | translate }}</span></div>
					</ng-container>
					<div class="ff-field" *ngIf="editing">
						<label>
							{{ "centro.centroData.active" | translate }}
							<mat-icon class="info" [matTooltip]="'centro.centroData.tooltipActivo' | translate">info</mat-icon>
						</label>
						<app-ds-toggle
							formControlName="activo"
							[label]="(estadoActivo ? 'common.active' : 'common.inactive') | translate"
						></app-ds-toggle>
					</div>
				</div>

				<!-- Descripción -->
				<div class="kv span2">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.centroData.description" | translate }}</div>
						<div class="kv-v">{{ descripcionVal }}</div>
					</ng-container>
					<div class="ff-field" *ngIf="editing">
						<label>
							{{ "centro.centroData.description" | translate }}<span class="req">*</span>
							<mat-icon class="info" [matTooltip]="'centro.centroData.tooltipdescription' | translate">info</mat-icon>
						</label>
						<div class="ff-box">
							<input type="text" formControlName="descripcion" />
						</div>
						<small class="ff-error" *ngIf="f['descripcion'].invalid && (f['descripcion'].touched || f['descripcion'].dirty)">
							{{ "messages.requiredField" | translate }}
						</small>
					</div>
				</div>

				<!-- Tipo de instalación (ancho completo; el CEBE vive en la card Vinculación) -->
				<div class="kv span2">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.centroData.installationType" | translate }}</div>
						<div class="kv-v">{{ tipoInstalacionLabel }}</div>
					</ng-container>
					<!-- Editable: los tipos disponibles son la UNIÓN de las ternas de los CeBe vinculados
					     (+ el tipo ya guardado, que siempre se conserva aunque su terna no aplique).
					     Sin CeBe vinculados se muestra un aviso (los tipos dependen del CeBe). -->
					<div class="ff-field" *ngIf="editing">
						<label>
							{{ "centro.centroData.installationType" | translate }}<span class="req">*</span>
							<mat-icon
								*ngIf="sinCebesVinculados"
								class="info warn"
								[matTooltip]="'centro.centroData.tipoInstalacionSinCebe' | translate"
								>warning</mat-icon
							>
						</label>
						<app-ds-select
							formControlName="tipoInstalacionID"
							[options]="tipoInstalacionList"
							[optionLabel]="tipoInstalacionLabelOf"
						></app-ds-select>
						<small class="ff-error" *ngIf="f['tipoInstalacionID'].invalid && (f['tipoInstalacionID'].touched || f['tipoInstalacionID'].dirty)">
							{{ "messages.requiredField" | translate }}
						</small>
					</div>
				</div>

				<!-- Ubicación: árbol geográfico (Dama_Geografia) filtrado al país del contrato.
				     Sustituye al par provincia + texto libre; la provincia (localizacionID) y la
				     ciudad se alimentan por detrás al guardar (server). Ver ADR-0010. -->
				<div class="kv flush span2">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.ubicacion.label" | translate }}</div>
						<div class="kv-v" [class.opx-muted]="ubicacionLabel === '—'">{{ ubicacionLabel }}</div>
					</ng-container>
					<div class="ff-field" *ngIf="editing">
						<label>{{ "centro.ubicacion.label" | translate }}<span class="req">*</span></label>
						<app-ubicacion-select
							formControlName="geografiaID"
							[codigoPais]="codigoPaisCentro"
						></app-ubicacion-select>
						<small class="ff-error" *ngIf="f['geografiaID'].invalid && (f['geografiaID'].touched || f['geografiaID'].dirty)">
							{{ "messages.requiredField" | translate }}
						</small>
					</div>
				</div>

				<!-- Detalle de ubicación (texto libre, opcional): dirección o matiz adicional. -->
				<div class="kv flush">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.ubicacion.detalle" | translate }}</div>
						<div class="kv-v" [class.opx-muted]="!f['ciudad'].value">{{ f['ciudad'].value || "—" }}</div>
					</ng-container>
					<div class="ff-field" *ngIf="editing">
						<label>{{ "centro.ubicacion.detalle" | translate }}</label>
						<div class="ff-box">
							<input type="text" formControlName="ciudad" [placeholder]="'centro.ubicacion.detallePlaceholder' | translate" />
						</div>
					</div>
				</div>

				<!-- Centro de actividad -->
				<div class="kv flush">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.centroData.centerActivity" | translate }}</div>
						<div class="kv-v" [class.opx-muted]="centroActividadLabel === '—'">{{ centroActividadLabel }}</div>
					</ng-container>
					<div class="ff-field" *ngIf="editing">
						<label>
							{{ "centro.centroData.centerActivity" | translate }}
							<mat-icon class="info" [matTooltip]="translate.instant('centro.centroData.descripActivityCenter')">info</mat-icon>
						</label>
						<app-ds-select
							formControlName="centroActividadID"
							[options]="centroActividadList"
							[optionLabel]="centroActividadLabelOf"
							[allowEmpty]="true"
						></app-ds-select>
						<small class="ff-error" *ngIf="f['centroActividadID'].invalid && (f['centroActividadID'].touched || f['centroActividadID'].dirty)">
							{{ "messages.requiredField" | translate }}
						</small>
					</div>
				</div>
			</div>
		</div>

		<!-- ============ LOCALIZACIÓN (mapa full-bleed; lat/long sin entrada manual:
		     el pin y el buscador — que acepta coordenadas — son la única vía) ============ -->
		<div class="card card-map">
			<div class="sec-head">
				<span class="sec-tile purple"><mat-icon>location_on</mat-icon></span>
				<div>
					<h3>{{ "centro.detail.locationTitle" | translate }}</h3>
					<p>{{ "centro.detail.locationSub" | translate }}</p>
				</div>
			</div>

			<app-centro-map-card
				*ngIf="centro"
				[centro]="centro"
				[detailFormGroup]="myDetailForm"
				[editing]="editing"
			></app-centro-map-card>
		</div>
	</div>

	<div class="card-row">
		<!-- ============ RESPONSABLE DEL CENTRO ============ -->
		<div class="card">
			<div class="sec-head">
				<span class="sec-tile blue"><mat-icon>person</mat-icon></span>
				<div>
					<h3>{{ "centro.detail.responsibleTitle" | translate }}</h3>
					<p>{{ "centro.detail.responsibleSub" | translate }}</p>
				</div>
			</div>

			<!-- Lectura: persona -->
			<div class="kv-grid c1" *ngIf="!editing">
				<div class="kv flush">
					<div class="kv-k">{{ "centro.centroData.plantManager" | translate }}</div>
					<div class="kv-v">
						<app-empleado-display [empleado]="parent?.responsableControl?.value"></app-empleado-display>
					</div>
				</div>
			</div>

			<!-- Edición: buscador de personas .ds (avatar con foto integrado en el campo) -->
			<div class="kv-grid c1" *ngIf="editing">
				<app-user-search
					[users]="parent.employees"
					[label]="'centro.centroData.plantManager' | translate"
					[placeholder]="'shared.refineSearch' | translate"
					[tooltip]="'centro.centroData.tooltipGerentePlanta' | translate"
					[value]="parent.responsableControl.value"
					(userSelected)="parent.onResponsableSelected($event)"
				></app-user-search>
			</div>
		</div>

		<!-- ============ VINCULACIÓN ============ -->
		<div class="card">
			<div class="sec-head">
				<span class="sec-tile amber"><mat-icon>link</mat-icon></span>
				<div>
					<h3>{{ "centro.detail.linkTitle" | translate }}</h3>
					<p>{{ "centro.detail.linkSub" | translate }}</p>
				</div>
			</div>
			<div class="kv-grid">
				<!-- Contrato padre: vínculo FIJO (el código del centro deriva del código del
				     contrato) → siempre solo-lectura. Info vía lookup de contexto no scopeado. -->
				<div class="kv flush">
					<div class="kv-k">{{ "lst.col.contract" | translate }}</div>
					<div class="kv-v" [class.opx-muted]="!parent?.contratoPadre">
						<ng-container *ngIf="parent?.contratoPadre; else sinContrato">
							<span class="opx-code">{{ parent.contratoPadre.codigo }}</span>
							{{ parent.contratoPadre.descripcion }}
						</ng-container>
						<ng-template #sinContrato>—</ng-template>
					</div>
				</div>

				<!-- CEBE(s) del centro: SUBSELECCIÓN de los CeBe del contrato. Editable con
				     manage sobre el centro (mismo gate de edición que el resto del formulario). -->
				<div class="kv flush">
					<ng-container *ngIf="!editing">
						<div class="kv-k">{{ "centro.centroData.cebesCenter" | translate }}</div>
						<div class="kv-v" [class.opx-muted]="sinCebesVinculados">{{ cebesLabel }}</div>
					</ng-container>
					<ng-container *ngIf="editing">
						<!-- Hay CeBe habilitados en el contrato: chips toggleables (multi-selección .ds) -->
						<div class="ff-field" *ngIf="!contratoSinCebes">
							<label>{{ "centro.centroData.cebesCenter" | translate }}</label>
							<div class="cebe-chips">
								<button
									type="button"
									class="cebe-chip"
									*ngFor="let c of cebesOpciones"
									[class.on]="isCebeSelected(c.id)"
									(click)="toggleCebe(c.id)"
								>
									<mat-icon>{{ isCebeSelected(c.id) ? "check" : "add" }}</mat-icon>
									<span class="cebe-chip-code">{{ c.codigo }}</span>
									<span class="cebe-chip-name">{{ c.descripcion }}</span>
								</button>
							</div>
							<small class="ff-hint">{{ "centro.centroData.cebesHint" | translate }}</small>
						</div>
						<!-- El contrato no tiene CeBe habilitados: no hay candidatos -->
						<ng-container *ngIf="contratoSinCebes">
							<div class="kv-k">{{ "centro.centroData.cebesCenter" | translate }}</div>
							<div class="kv-v opx-muted">
								—
								<mat-icon
									class="info warn"
									[matTooltip]="'centro.centroData.cebesSinContrato' | translate"
									>warning</mat-icon
								>
							</div>
						</ng-container>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</form>
